module.exports = __webpack_public_path__ + "static/img/6.06a6a48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/6.png
// module id = pH+A
// module chunks = 0